import { render, staticRenderFns } from "./TrainingGroupsSide.vue?vue&type=template&id=3888f542&scoped=true&"
import script from "./TrainingGroupsSide.vue?vue&type=script&lang=js&"
export * from "./TrainingGroupsSide.vue?vue&type=script&lang=js&"
import style0 from "./TrainingGroupsSide.vue?vue&type=style&index=0&id=3888f542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888f542",
  null
  
)

export default component.exports